import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IInvoiceState }        from 'Redux/Slices/Invoice/InvoiceSlice';
import { removeActionTypes }    from 'Utils/ReducerUtility';

export const sendTicketsFromInvoiceRequest = (state: Draft<IInvoiceState>, { type }: PayloadAction<{ id: string }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const sendTicketsFromInvoiceSuccess = (state: Draft<IInvoiceState>, { type }: PayloadAction) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
};

export const sendTicketsFromInvoiceFailure = (state: Draft<IInvoiceState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
